const AMPLITUDE_ENDPOINT = "https://api2.amplitude.com/2/httpapi";
const DEFAULT_TIMEOUT_MS = 350;
const COOKIE_CLIENT_REFERENCE_ID = "p_qid";
const FALLBACK_AMPLITUDE_API_KEY = "347365164b241a9e95ed87324dd1c6e2";

const getCookieValue = (name) => {
  if (typeof document === "undefined") return "";
  const cookie = document.cookie
    .split(";")
    .map((part) => part.trim())
    .find((part) => part.startsWith(`${name}=`));
  if (!cookie) return "";
  const value = cookie.slice(name.length + 1);
  try {
    return decodeURIComponent(value);
  } catch (_) {
    return value;
  }
};

const buildDedupeKey = ({ type, paywall, revenue, userId, extraKey }) =>
  [
    "amplitude_purchase",
    type || "",
    paywall || "",
    revenue != null ? String(revenue) : "",
    userId || "",
    extraKey || "",
  ].join("|");

const markIfNew = (dedupeKey) => {
  if (typeof window === "undefined") return true;
  try {
    const storageKey = `amp_${dedupeKey}`;
    if (sessionStorage.getItem(storageKey)) return false;
    sessionStorage.setItem(storageKey, "1");
    return true;
  } catch (_) {
    return true;
  }
};

export const getClientReferenceId = () => {
  if (typeof window === "undefined") return "";
  const params = new URLSearchParams(window.location.search || "");
  const fromQuery = (params.get("client_reference_id") || "").trim();
  if (fromQuery) return fromQuery;

  const fromCookie = (getCookieValue(COOKIE_CLIENT_REFERENCE_ID) || "").trim();
  if (fromCookie) return fromCookie;

  try {
    const fromStorage = (sessionStorage.getItem("clientReferenceId") || "").trim();
    return fromStorage;
  } catch (_) {
    return "";
  }
};

export const sendAmplitudePurchase = async ({
  userId,
  revenue,
  currency = "usd",
  product,
  paywall,
  type,
  extraKey,
  timeoutMs = DEFAULT_TIMEOUT_MS,
} = {}) => {
  if (typeof window === "undefined") return;

  const resolvedUserId = (userId || getClientReferenceId() || "").trim();
  const apiKey =
    process.env.REACT_APP_AMPLITUDE_API_KEY || FALLBACK_AMPLITUDE_API_KEY;
  const normalizedRevenue =
    revenue != null && Number.isFinite(Number(revenue)) ? Number(revenue) : undefined;

  if (!resolvedUserId || !apiKey || normalizedRevenue == null || !product) return;

  const dedupeKey = buildDedupeKey({
    type,
    paywall,
    revenue: normalizedRevenue,
    userId: resolvedUserId,
    extraKey,
  });
  const isNew = markIfNew(dedupeKey);
  if (!isNew) return;

  const payload = {
    api_key: apiKey,
    events: [
      {
        event_type: "Purchase",
        user_id: resolvedUserId,
        time: Date.now(),
        event_properties: {
          revenue: normalizedRevenue,
          currency: String(currency).toLowerCase(),
          product,
          ...(paywall ? { paywall } : {}),
        },
      },
    ],
  };

  await Promise.race([
    fetch(AMPLITUDE_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => undefined),
    new Promise((resolve) => setTimeout(resolve, timeoutMs)),
  ]);
};



